import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { inventarioAPI } from '../../services/api';

// Async thunk para obtener eventos de inventario
export const fetchInventoryEvents = createAsyncThunk(
  'inventoryEvents/fetchInventoryEvents',
  async (filters, { rejectWithValue }) => {
    try {
      const response = await inventarioAPI.getEvents(filters);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const inventoryEventsSlice = createSlice({
  name: 'inventoryEvents',
  initialState: {
    events: [],
    loading: false,
    error: null,
    filters: {
      ubicacion: 'TODOS', // TODOS, Campo, Warehouse USA
      producto_id: null,
      tipo_evento: null, // null, AGREGAR, REBAJAR
      fecha_desde: null,
      fecha_hasta: null
    }
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        ubicacion: 'TODOS',
        producto_id: null,
        tipo_evento: null,
        fecha_desde: null,
        fecha_hasta: null
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload || [];
      })
      .addCase(fetchInventoryEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setFilters, clearFilters } = inventoryEventsSlice.actions;

// Selectors
export const selectInventoryEvents = (state) => state.inventoryEvents.events;
export const selectInventoryEventsLoading = (state) => state.inventoryEvents.loading;
export const selectInventoryEventsError = (state) => state.inventoryEvents.error;
export const selectInventoryEventsFilters = (state) => state.inventoryEvents.filters;

export default inventoryEventsSlice.reducer;
